<template>
  <div class="no-data">
    <h5 class="mb-2">
      <slot name="noData">
        No Data Available in
        <span class="document-type">
          {{ label }} {{ documentType }}
        </span>
      </slot>
    </h5>
    <p>
      <slot name="description">
        There is no
        {{ documentType === 'Requisitions' ? 'requisition' : 'post' }}
        data available for your selection.
      </slot>
    </p>
    <slot name="content" />
  </div>
</template>

<script>
export default {
  name: 'NoDataBlock',
  props: {
    label: {
      type: String,
      default: '',
    },
    documentType: {
      type: String,
      default: 'Posts',
    },
  },
};
</script>

<style scoped lang="less">
@import '@/less/mixins';
.no-data {
  background: @white;
  border: 1px solid @stroke-default;
  padding: 24px;
  border-radius: 10px;
  text-align: center;
  color: rgba(@grey-900, .5);
  > p {
    &:last-child {
      margin: 0;
    }
  }
  &.border-bottom {
    border-bottom: 2px solid @stroke-default;
  }

  .document-type {
    color: @text-darkest;
  }
}
</style>
